import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  isBetSlipModalOpen: boolean;
}

const initialState: UiState = {
  isBetSlipModalOpen: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setBetSlipModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isBetSlipModalOpen = action.payload;
    },
  },
});

export const { setBetSlipModalOpen } = uiSlice.actions;

export default uiSlice.reducer;
